import React from 'react';
import {RegistrationStepsProvider} from "./registration-steps/registration-steps-context";
import {CartProvider} from "./cart/cart-context";
import {DashboardProvider} from "./dashboard/dashboard-context";
import {PurchaseProvider} from "./purchase/purchase-context";

const DataProvider = ({...props}) => {
    return (
        <DashboardProvider>
            <PurchaseProvider>
                <CartProvider>
                    <RegistrationStepsProvider>
                        {props.children}
                    </RegistrationStepsProvider>
                </CartProvider>
            </PurchaseProvider>
        </DashboardProvider>
    );
};

export default DataProvider;